import { call, put, takeLatest } from 'redux-saga/effects';
import {DELETE_PRODUCT_REQUEST, deleteProductFailure, deleteProductSuccess} from "../actions/delete-product-actions";
import {deleteProduct} from "../../../services/product/product-service";


function* deleteProductSaga(action) {
    try {
        yield call(deleteProduct, action.payload);
        yield put(deleteProductSuccess(action.payload));
    } catch (e) {
        yield put(deleteProductFailure(e.message));
    }
}

export default function* watchDeleteProduct() {
    yield takeLatest(DELETE_PRODUCT_REQUEST, deleteProductSaga);
}